import objectFitImages from 'object-fit-images';
import 'core-js/features/array/from';

document.addEventListener('lazybeforeunveil', function(e) {
  const target = e.target;
  /**
   * Add class `lazy` to the elenent to enable background lazyloading
   * data-bg="img.jpg" => style="background-image: url(img.jpg)"
   */
  var bg = target.getAttribute('data-bg');
  if (bg) {
    target.style.backgroundImage = 'url(' + bg + ')';
  }

  /**
   * Add simple support for lazyloading stuff
   *
   * Add class `lazy` to the element to enable lazyloading
   * Prefix anything with 'data-lazy-' and the suffix will be added as attribute (for example data-lazy-src => src="...")
   */
  const lazyPrefixRegex = /^data-lazy-([-\w]+)$/;

  Array.from(target.attributes).forEach(attr => {
    if (!lazyPrefixRegex.test(attr.name)) {
      return;
    }

    let wantedAttr = '';
    attr.name.replace(lazyPrefixRegex, (all, match) => {
      wantedAttr = match;
    });

    target.removeAttribute(attr.name);
    target.setAttribute(wantedAttr, attr.value);
  });
});

/**
 * use data-lazyloaded="{classes: { '#test-element': 'test-class'}}" to append classes to other element when current element is lazyloaded
 */
document.addEventListener('lazyloaded', e => {
  const lazyloaded = e.target.attributes['data-lazyloaded'];
  if(!lazyloaded) {
    return;
  }

  let settings = lazyloaded.value;

  try {
    settings = JSON.parse(settings);
  } catch(e) {
    return;
  }

  // Add classes to elements that are defined in the classes object
  if(settings.classes) {
    Object.keys(settings.classes).forEach(selector => {
      const targetEl = document.querySelector(selector);
      if(!targetEl) {
        return;
      }

      targetEl.classList.add(settings.classes[selector]);
    });
  }


});

// Run object-fit-images if needed
document.addEventListener('lazyloaded', e => {
  if(e.target.classList.contains('js-object-fit')) {
    objectFitImages(e.target);
  }
});
